import Belarus from '@/shared/ui/LanguageIcon/svg/Belarus.vue'
import Russia from '@/shared/ui/LanguageIcon/svg/Russia.vue'
import UnitedKingdom from '@/shared/ui/LanguageIcon/svg/UnitedKingdom.vue'
import Ukraine from '@/shared/ui/LanguageIcon/svg/Ukraine.vue'

export default {
	be: Belarus,
	ru: Russia,
	en: UnitedKingdom,
	ua: Ukraine
}
